import { registerComponent, getComponentConfig } from "helpers";

registerComponent(
  "video-player",
  class VideoPlayer extends HTMLElement {
    async connectedCallback() {
      this.config = getComponentConfig(this);
      this.externalVideo = this.querySelector("iframe");
      this.nativeVideo = this.querySelector("video");

      this.bindEvents();
    }

    async fetchVimeoPreviewImageSrc() {
      const response = await fetch(
        `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${this.config.externalID}&format=json&width=1200`,
      );
      const data = await response.json();
      return data.thumbnail_url;
    }

    bindEvents() {
      this.renderPreviewImage();
      this.addEventListener("click", this.handleStartPlay.bind(this));
      this.handleModalContext();
    }

    handleStartPlay() {
      if (this.nativeVideo) {
        this.play();
      } else {
        this.renderVideo();
      }
    }

    renderPreviewImage() {
      [this.previewButton] = this.getElementsByTagName("button");

      if (this.config.autoplay) {
        return;
      }

      if (this.config.previewImage) {
        this.previewButton.insertAdjacentHTML(
          "beforeend",
          this.config.previewImage,
        );

        return;
      }

      this.renderExternalPreview();
    }

    async renderExternalPreview() {
      if (this.config.host === "youtube") {
        this.previewImageSrc = `https://i.ytimg.com/vi/${this.config.externalID}/maxresdefault.jpg`;
      } else {
        this.previewImageSrc = await this.fetchVimeoPreviewImageSrc();
      }

      [this.previewButton] = this.getElementsByTagName("button");
      this.previewImage = document.createElement("img");
      this.previewImage.setAttribute("src", this.previewImageSrc);
      this.previewImage.setAttribute(
        "class",
        "video-player__preview-image fit-image",
      );
      this.previewImage.setAttribute("loading", "lazy");
      this.previewButton.append(this.previewImage);
    }

    renderVideo() {
      if (this.config.host === "youtube") {
        this.videoSrc = `https://www.youtube.com/embed/${this.config.externalID}`;
      } else {
        this.videoSrc = `https://player.vimeo.com/video/${this.config.externalID}`;
      }

      this.externalVideo =
        this.externalVideo || document.createElement("iframe");
      const width = this.previewButton.offsetWidth;
      const height = this.previewButton.offsetHeight;

      this.externalVideo.setAttribute("src", `${this.videoSrc}?autoplay=1`);
      this.externalVideo.setAttribute("allowfullscreen", "1");
      this.externalVideo.setAttribute("allow", "autoplay; encrypted-media");
      this.externalVideo.setAttribute(
        "class",
        "video-player__iframe fit-image",
      );
      this.externalVideo.setAttribute("width", width);
      this.externalVideo.setAttribute("height", height);
      this.externalVideo.setAttribute("frameborder", "0");

      this.setAttribute("ready", true);
      this.appendChild(this.externalVideo);

      this.play();
    }

    handleModalContext() {
      const modal = this.closest("[data-modal]");

      if (modal) {
        modal.addEventListener("modalOpen", this.handleStartPlay.bind(this));
        modal.addEventListener("modalClose", this.reset.bind(this));
      }
    }

    play() {
      this.nativeVideo?.play();
      this.classList.add("video-player--playing");
    }

    reset() {
      this.externalVideo?.remove();
      this.nativeVideo?.pause();
      this.classList.remove("video-player--playing");
    }
  },
);
